/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @next/next/no-img-element */
import { FC } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';

import { Verified } from '@components/avatar';
import { preview } from '@utils/wallet';
import { Box, Button, Tag, Text } from '@versumstudios/ui';

interface IUserComponent {
  id: string;
  name: string;
  address?: string;
  verified_on_chain: boolean;
  parsedScreenName: string;
  isYou?: boolean;
  isCreator?: boolean;
}

export const UserComponent: FC<IUserComponent> = ({
  id,
  name,
  verified_on_chain,
  address,
  isYou,
  isCreator,
  parsedScreenName,
}) => {
  const router = useRouter();

  return (
    <Box css={{ flexDirection: 'column' }}>
      {name && (
        <Link href={`/user/${id}/created`} locale={router.locale} prefetch={false} passHref>
          <Button as="a" variant="basic" css={{ display: 'flex', fontSize: 14, alignItems: 'center' }}>
            {parsedScreenName}
            {verified_on_chain && <Verified size={10} secondary />}
            {!isYou && isCreator && <Tag css={{ marginLeft: '$space$4' }} label="Creator" />}
            {isYou && <Tag css={{ marginLeft: '$space$4' }} label="You" />}
          </Button>
        </Link>
      )}
      {false && (
        <Text unset css={{ color: '$secondaryFill', fontSize: 10 }}>
          {preview(address!)}
        </Text>
      )}
    </Box>
  );
};
